import type { INDENTS } from 'vars/indents'
import type { LAYOUT } from 'vars/layout-settings'

import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const NoSearchResultsSC = styled.div<{
  paddings?: Array<FIXED_INDENTS | INDENTS | LAYOUT>
}>`
  flex: 1;
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(${FIXED_INDENTS.INDENT_30});

  ${MEDIA.MIN_600} {
    flex-direction: row;
    gap: var(${FIXED_INDENTS.INDENT_40});
  }
`
